module.exports = __webpack_public_path__ + "img/4.d2cb9858.jpg";